<template>
  <div class="row fw-news">
    <div class="col-12 col-lg-5 py-3">
      <template v-if="mode === 'list'">
        <header-selector
          :options="headerOptions"
          :selected="category"
          :right="false"
          class="mb-1"
          @change="
            (to) => {
              changeCategory(to)
            }
          "
        />
        <news
          :news="news[category]"
          @newsclick="
            (news) => {
              openArticle(news)
            }
          "
          class="news-table"
        />
      </template>
      <template v-if="mode === 'expanded' && !loading">
        <p>
          <a class="turnback" href="#" @click.prevent="closeArticle()">
            <svg
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 11L1 6L6 1"
                stroke="#C2C2D6"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>{{ $t('dashboard.news.backToFeed') }}</span>
          </a>
        </p>
        <div class="closup Custom_Scrollbar pr-3">
          <h4>{{ article.title | stripTags }}</h4>
          <p>{{ post.content | stripTags }}</p>
        </div>
        <p class="desc">
          <span
            ><span class="title">{{ $t('dashboard.news.source') }}: </span>
            <a :href="article.url">{{ blogName }}</a></span
          ><br />
          <span
            ><span class="title">{{ $t('dashboard.news.tags') }}: </span
            ><template v-for="(tag, i) in post.tags"
              >{{ tag.Name }}{{ i === post.tags.length - 1 ? '' : ',' }}
            </template>
          </span>
          <!-- <span><span class="title">Подписчиков</span></span> -->
        </p>
      </template>
    </div>
    <div class="col-12 col-lg-7 container-fluid">
      <h6 class="chart-title pt-3">
        {{ $t('dashboard.news.graphsTitles.title') }} {{ tickerName }} -
        {{ headerOptions.filter((el) => category == el.name)[0].text }}
      </h6>
      <div class="row">
        <div class="col-12 col-lg-6 graph">
          <h4 class="pb-2">
            {{ $t('dashboard.news.graphsTitles.sentiment') }} {{ tickerName }}
          </h4>
          <tonality-area
            :chartData="charts.tonality"
            :percent="true"
            :styles="{ height: '250px', width: '100%', position: 'relative' }"
          />
        </div>
        <div class="col-12 col-lg-6 graph">
          <h4 class="pb-2">
            {{ $t('dashboard.news.graphsTitles.mentionsAmount') }}
            {{ tickerName }}
          </h4>
          <tonality-area
            :chartData="charts.mentions"
            :numberlimit="0"
            :styles="{ height: '250px', width: '100%', position: 'relative' }"
          />
        </div>
        <div class="col-12 col-lg-12 graph half">
          <h4 class="pb-2">
            {{ $t('dashboard.news.graphsTitles.sources') }} {{ tickerName }}
          </h4>
          <sources-pie
            :chartData="charts.sources"
            :styles="{ height: '160px', width: '360px', position: 'relative' }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import filters from '@/utils/filters'
import News from '@/components/Widgets/News'
import HeaderSelector from '@/components/Widgets/HeaderSelector'
import SourcesPie from '@/components/Widgets/charts/sourcesPie.vue'
import TonalityArea from '@/components/Widgets/charts/tonalityArea.vue'

const DEFAULTCATEGORY = 'magazines'

export default {
  components: {
    news: News,
    'header-selector': HeaderSelector,
    'sources-pie': SourcesPie,
    'tonality-area': TonalityArea,
  },
  data() {
    return {
      // mode: 'list', // ['list', 'closup']
      post: {
        content: '',
        tags: [],
        url: '',
        blogName: '',
      },
      charts_: {
        sources: [],
      },
      loading: true,
    }
  },
  methods: {
    changeCategory(to) {
      this.$router.push({
        path: this.$route.path,
        query: {
          m: 'news',
          cat: to,
        },
      })
    },
    openArticle(n) {
      this.$router.push({
        path: this.$route.path,
        query: {
          m: 'news',
          cat: _.get(this, '$route.query.cat', DEFAULTCATEGORY),
          pid: n,
        },
      })
    },
    closeArticle() {
      this.$router.push({
        path: this.$route.path,
        query: {
          m: 'news',
          cat: _.get(this, '$route.query.cat', DEFAULTCATEGORY),
        },
      })
    },
    loadData() {
      if (this.postId == -1) return
      const regex = /<br\s*[/]?>/gi
      this.loadGraphs()
      this.$store
        .dispatch('request/loadArticle', {
          postId: this.postId,
          type: this.category,
        })
        .then((res) => {
          this.loading = false
          this.post.content = String(_.get(res, 'data.Content', '')).replace(
            regex,
            '\n'
          )
          this.post.tags = _.get(res, 'data.Tags', [])
          this.post.url = _.get(res, 'data.Url', [])
          this.post.blogName = _.get(res, 'data.BlogHost', [])
        })
    },
    loadGraphs(period = '2w') {
      this.$store
        .dispatch('request/loadStats', {
          period,
          ticker: this.$route.params.ticker,
        })
        .then((res) => {
          this.charts_ = res.data
        })
    },
    goto(item) {
      window.open(item.text, '_blank')
    },
  },
  computed: {
    ...mapState('news', ['news', 'search', 'statistics', 'average']),
    category() {
      return _.get(this, '$route.query.cat', DEFAULTCATEGORY)
    },
    postId() {
      return Number(_.get(this, '$route.query.pid', '-1'))
    },
    mode() {
      return this.postId >= 0 ? 'expanded' : 'list' // ['list', 'expanded']
    },
    article() {
      if (!this.mode == 'expanded' || this.postId < 0) return {}

      const filtered = this.news[this.category].filter(
        (post) => Number(post.id) === this.postId
      )
      return filtered.length > 0 ? filtered[0] : {}
    },
    tickerName() {
      return String(this.$route.params.ticker).toUpperCase()
    },
    blogName() {
      return this.post.blogName == 'api-invest-gw.tinkoff.ru'
        ? 'Тинькофф Пульс'
        : this.post.blogName
    },
    headerOptions() {
      return [
        {
          name: 'magazines',
          text: this.$t('dashboard.news.selector.magazines'),
        },
        {
          name: 'socials',
          text: this.$t('dashboard.news.selector.socials'),
        },
      ]
    },
    charts() {
      const colors = [
        '#628395',
        '#96897B',
        '#DFD5A5',
        '#DBAD6A',
        '#CF995F',
        '#606598',
      ]

      const sources = Array.from(
        _.get(this, 'charts_.sources.' + this.category, [])
      ).filter((el) => el.count > 0)
      const sourcesSum = _.sumBy(sources, 'count')

      const tonalities = Array.from(
        _.get(this, '$store.state.news.statistics.' + this.category, [])
      )
      const mentions = Array.from(
        _.get(this, '$store.state.news.statisticsMentions.' + this.category, [])
      )

      return {
        sources: {
          labels: sources.map((el) => {
            const MAXLEGENDLEN = 20

            let res
            if (el.BlogHost === '_others') res = this.$t('messages.others')
            else if (
              String(el.BlogHost).search('api-invest-gw.tinkoff.ru') > -1
            )
              res = 'Тинькофф Пульс'
            else
              res =
                String(el.BlogHost).length > MAXLEGENDLEN
                  ? String(el.BlogHost).slice(0, MAXLEGENDLEN) + '...'
                  : el.BlogHost

            return Number((el.count / sourcesSum) * 100).toFixed(0) + '% ' + res
          }),
          datasets: [
            {
              data: sources.map((el) => el.count),
              backgroundColor: colors,
            },
          ],
        },
        tonality: {
          labels: tonalities.map((t) => new Date(t.time * 1000)),
          datasets: [{ data: tonalities.map((t) => t.value * 100) }],
        },
        mentions: {
          labels: mentions.map((t) => new Date(t.publishDate)),
          datasets: [
            {
              data: mentions.map(
                (t) => t.tonality2 + t.tonality3 + t.tonality4
              ),
            },
          ],
        },
      }
    },
  },
  filters: {
    stripTags: filters.stripTags,
  },
  watch: {
    $route() {
      this.$nextTick(function() {
        if (this.postId) this.loadData()
        // if (this.category) this.loadGraphs()
      })
    },
    // category(to) {
    //   if (!_.isUndefined(to))
    // },
  },
  mounted() {
    this.loadData()
    this.loadGraphs()
  },
}
</script>

<style lang="scss">
.fw-news {
  color: black;
  h4 {
    font-weight: 300;
  }
  .news-table {
    // height: calc(100vh - 370px);
    height: 510px;
    max-height: initial;
    min-height: 300px;
  }
  .closup.Custom_Scrollbar {
    height: 510px;
    max-height: 150%;
    overflow: auto;
  }
  .table-with-search .tableCover {
    height: initial;
    max-height: 350px;
  }
  @media (max-width: 991px) {
    .closup.Custom_Scrollbar {
      height: auto;
      max-height: 300px;
      overflow: auto;
    }
    .news-table {
      height: 310px;
      margin-bottom: 0;
    }
    .table-with-search .tableCover {
      height: initial;
      max-height: 310px;
    }
  }
  @media (min-width: 992px) {
    .table-with-search .tableCover {
      height: calc(100vh - 70px);
      max-height: 1000px;
      min-height: 300px;
    }
  }

  .limit-height {
    max-height: calc(100vh - 300px);
    min-height: 300px;
  }
  p.content {
    white-space: pre-line;
    font-size: 1rem;
    line-height: 1.5rem;
    color: #000000;
  }
  .desc {
    font-size: 0.8rem;
    > span {
      margin-bottom: 7px;
    }
    a {
      color: black;
      text-decoration: underline;
    }

    .title {
      color: #8a8a8a;
    }
  }
  .graph {
    height: 305px;

    &.half {
      height: 210px;
    }

    h4 {
      font-family: 'PT Sans Caption';
      font-style: normal;
      font-weight: normal;
      font-size: 1rem;
      line-height: 1.5rem;

      font-feature-settings: 'liga' off;
    }
  }
}
</style>
